const model = {
    name: 'Ordercloud',
    buildInterface: true,
    file: 'ocContext',
    properties: {
        sellerId: { type: 'string' },
        requiredInventoryLocations: { type: 'array', name: 'requiredInventoryLocations' },
    },
};
export default model;
